import Level from '../core/level.js'
import questions from './commons/black_box_questions.js'

const level = new Level({
    name: 'black_box_short',
    dependencies: []
})


const selectedQuestions = ['doubleSymbols', 'plusOne', 'timesTwo', 'lastDigit']
selectedQuestions.forEach(key => level.addQuestion(questions[key]))

export default level

